import React, { lazy, Suspense, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import arabicvinylbg from "../assets/Background/fullbg.avif";
import "./Home.css";
import ArabicVinylData from "./ArabicVinyl/ArabicVinylData";
import PopModernData from "./ArabicVinyl/PopModernData";
import AllTimesVinylData from "./ArabicVinyl/AllTimesVinylData";
import CartDrawer from "./Cart/CartDrawer";
import { useCart } from "./Cart/CartContext";
const IntroVideo = lazy(() => import("./Home/IntroVideo"));
const Carousel = lazy(() => import("./Home/Carousel"));
const IntroAnimatedText = lazy(() => import("./Home/IntroAnimatedText"));
const Footer = lazy(() => import("./Home/Footer"));
// const ArabicVinylCarousel = lazy(
//   () => import("./ArabicVinyl/ArabicVinylCarousel"),
// );
// const MaisElRimSection = lazy(() => import("./Home/MaisElRimSection"));
// const SectionTitle = lazy(() => import("./Home/SectionTitle"));
const AboutUs = lazy(() => import("./AboutUs"));
const Clients = lazy(() => import("./Home/Clients/Clients"));
const Immortal = lazy(() => import("./Home/Immortal/ImmortalHome"));
const CategoryCarouselV2 = lazy(
  () => import("./CategoryCarousel/CategoryCarouselV2"),
);

const Loader = () => <div style={{ height: "350px" }} />;
const INTRO_KEY = "rt_intro_played";
const Home = ({ onReadyForFooter, Ip, hasSeenIntro, setHasSeenIntro }) => {
  const navigate = useNavigate();
  const { cartItems, addToCart, removeItem, increaseQty, decreaseQty } =
    useCart();

  // const [showIntro, setShowIntro] = useState(!hasSeenIntro);
  // const hasPlayedIntro = localStorage.getItem(INTRO_KEY) === "1";
  const [animationPhase, setAnimationPhase] = useState(
    "text",
  );

  // const [animationPhase, setAnimationPhase] = useState(
  //   hasSeenIntro ? "text" : "video",
  // );
  const [carouselReady, setCarouselReady] = useState(true);

  const handleIntroAnimationComplete = () => {
    setAnimationPhase("carousel");
    setTimeout(() => setCarouselReady(true), 350);
  };
  //  useEffect(() => {
  //    const hasPlayedIntro = localStorage.getItem(INTRO_KEY) === "1";
  //   if (!hasPlayedIntro) {
  //     setShowIntro(true); // show video only if not played
  //   }else{
  //     setShowIntro(false);
  //   }
  //   onReadyForFooter?.(false);
  // }, [onReadyForFooter]);

  // useEffect(() => {
  //   if (hasSeenIntro) {
  //     setShowIntro(false);
  //   } else {
  //     setShowIntro(true);
  //   }
  // }, [hasSeenIntro]);

  const handleVideoFinish = () => {
    // Hide the intro video and start the text animation.
    localStorage.setItem(INTRO_KEY, "1");
    // setShowIntro(false);
    setHasSeenIntro(true);
    setAnimationPhase("text");
  };

  const [cartOpen, setCartOpen] = useState(false);
  // const handleScrollDown = () => {
  //   window.scrollBy({
  //     top: 600,
  //     behavior: "smooth",
  //   });
  // };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      {/* {showIntro && (
        <Suspense fallback={null}>
          <IntroVideo onFinish={handleVideoFinish} />
        </Suspense>
      )} */}

      {/* {!showIntro && ( */}
      <div className="home-container">
        <div
          className={`intro-text-background ${animationPhase === "carousel" ? "background-layer" : "fullscreen"
            }`}
        >
          <Suspense fallback={null}>
            <IntroAnimatedText
              forceBackground={animationPhase === "carousel"}
              onAnimationComplete={handleIntroAnimationComplete}
            />
          </Suspense>
        </div>

        {animationPhase === "carousel" && (
          <div
            id="section-carousel"
            className={`carousel-foreground ${carouselReady ? "visible" : ""
              }`}
          >
            <Suspense fallback={<Loader />}>
              <Carousel scrollDown="section-about" />
              {/* <div
                  className="scroll-down-indicator"
                  onClick={handleScrollDown}
                >
                </div> */}
            </Suspense>
          </div>
        )}

        <div id="section-about" style={{ backdropFilter: "blur(18px)" }}>
          <Suspense fallback={<Loader />}>
            <AboutUs scrollDown="section-immortal" />
          </Suspense>
        </div>

        <div id="section-immortal">
          <Suspense fallback={<Loader />}>
            <Immortal scrollDown="section-catcarousel" />
          </Suspense>
        </div>

        {animationPhase === "carousel" && carouselReady && (
          <div
            id="section-catcarousel"
            className="arabic-vinyl-section"
          // style={{
          //   backgroundImage: `url(${arabicvinylbg})`,
          //   backgroundRepeat: "no-repeat",
          //   backgroundSize: "cover",
          //   backgroundPosition: "center",
          // }}
          >
            <div
            // style={{
            //   position: "relative",
            //   // minHeight: "100vh",
            //   backgroundImage: `url(${arabicvinylbg})`,
            //   backgroundRepeat: "no-repeat",
            //   backgroundSize: "cover",
            //   backgroundPosition: "center",
            // }}
            >
              <Suspense fallback={<Loader />}>
                <CategoryCarouselV2
                  id="arabic-vinyl"
                  title="Arabic Vinyl"
                  ArabicVinylData={ArabicVinylData}
                  onAddToCart={(item, qty, sourceEl) =>
                    addToCart(item, qty, sourceEl)
                  }
                  direction="ltr"
                  category="Arabic"
                />
              </Suspense>

              <Suspense fallback={<Loader />}>
                <CategoryCarouselV2
                  id="pop-modern"
                  title="Pop Modern"
                  ArabicVinylData={PopModernData}
                  onAddToCart={(item, qty, sourceEl) =>
                    addToCart(item, qty, sourceEl)
                  }
                  direction="ltr"
                />
              </Suspense>
              <Suspense fallback={<Loader />}>
                <CategoryCarouselV2
                  id="arabic-vinyl-2"
                  title="All Time Classics Vinyl"
                  ArabicVinylData={AllTimesVinylData}
                  onAddToCart={(item, qty, sourceEl) =>
                    addToCart(item, qty, sourceEl)
                  }
                  direction="ltr"
                />
              </Suspense>
              <Suspense fallback={<Loader />}>
                <CategoryCarouselV2
                  id="classical-vinyl"
                  title="Classical Music Vinyl"
                  ArabicVinylData={ArabicVinylData}
                  onAddToCart={(item, qty, sourceEl) =>
                    addToCart(item, qty, sourceEl)
                  }
                  direction="ltr"
                  category="Classical"
                />
              </Suspense>
              {/* <Suspense fallback={<Loader />}>
                  <BestVinyl title="Arabic Vinyl" />
                </Suspense> */}
              {/* <Suspense fallback={<Loader />}>
                  <Immortal/>
                </Suspense> */}

              {/* <Suspense fallback={<Loader />}>
                <SectionTitle title="Arabic Vinyl" />
              </Suspense> */}
              {/* <Suspense fallback={<Loader />}>
                <MaisElRimSection />
              </Suspense> */}

              <Suspense fallback={<Loader />}>
                <Clients />
              </Suspense>
              <Suspense fallback={<Loader />}>
                <Footer />
              </Suspense>
              <CartDrawer
                isOpen={cartOpen}
                onClose={() => setCartOpen(false)}
                items={cartItems}
                onRemoveItem={removeItem}
                onIncreaseQty={increaseQty}
                onDecreaseQty={decreaseQty}
                onViewCart={() => navigate("/cart")}
                onCheckout={() => navigate("/CheckOut")}
                onContinueShopping={() => setCartOpen(false)}
              />
            </div>
          </div>
        )}
      </div>
      {/* )} */}
    </>
  );
};

export default Home;
